import { PATH_ADD_JOINHOLDER, PATH_JOINHOLDER_CONFIRMATION } from 'constants/uTagConstants/paths';
import cryptoJS from 'crypto-js';
import { recordPage } from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';

const doTagPage = ({ userProfile, detalleProducto }) => {
    const { recordId, userId, product, promoCode = '', investmentType, docNumber } = userProfile;
    const pathForTag = PATH_ADD_JOINHOLDER;
    const jointHolderAccount = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    const tipoOnboarding = investmentType;
    const custom = {
        identificadorOnboarding: docNumber ? cryptoJS.SHA256(docNumber).toString() : '',
        event_name: 'step_add_intervener',
        pageName: '/onboarding/step2a/addIntervener',
        sectionFamily: 'banking',
        sectionCategory: 'onboarding',
        sectionName: 'userOnboarding',
        interactionType: 'funnel',
        serviceType: 'onboarding',
        processType: 'onboarding',
        processStep: 'step2a',
        processDetail: 'addIntervener',
        onboardingHolderType: jointHolderAccount.typeHolder === 'primer titular' ? 'firstTitular' : 'secondTitular',
        onboardingType: investmentType,
    };
    recordPage(
        pathForTag,
        recordId,
        userId,
        product,
        detalleProducto,
        promoCode,
        jointHolderAccount,
        '',
        '',
        tipoOnboarding,
        custom
    );
};

const doTagPageOtpView = ({ userProfile, products }) => {
    const { docNumber, recordId, userId, product, promoCode = '', investmentType } = userProfile;
    const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
    const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

    const custom = {
        identificadorOnboarding: docNumberEncrypted,
        event_name: 'step_confirmation_intervener',
        pageName: '/onboarding/step2b/confirmationIntervener',
        sectionFamily: 'banking',
        sectionCategory: 'onboarding',
        sectionName: 'userOnboarding',
        interactionType: 'funnel',
        serviceType: 'onboarding',
        processType: 'onboarding',
        processStep: 'step2b',
        processDetail: 'confirmationIntervener',
        onboardingHolderType: JointHolderInfo.typeHolder === 'primer titular' ? 'firstTitular' : 'secondTitular',
        onboardingType: investmentType,
    };

    recordPage(
        PATH_JOINHOLDER_CONFIRMATION,
        recordId,
        userId,
        product,
        products.get('productsDescription'),
        promoCode,
        JointHolderInfo,
        '',
        '',
        investmentType,
        custom
    );
};

export default { doTagPage, doTagPageOtpView };
